import { render } from "./SectionTitle.vue?vue&type=template&id=043f7a74&scoped=true&ts=true"
import script from "./SectionTitle.vue?vue&type=script&lang=ts"
export * from "./SectionTitle.vue?vue&type=script&lang=ts"

import "./SectionTitle.vue?vue&type=style&index=0&id=043f7a74&lang=scss&scoped=true"

import exportComponent from "/home/administrator/tourstat-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-043f7a74"]])

export default __exports__